import { Capacitor } from "@capacitor/core";

// Central, testable platform helper. Native = the Capacitor iOS/Android app; web = everything
// else (browser / PWA). Web is the default. Do NOT duplicate this logic in components.
export function isNativePlatform() {
  return Capacitor.isNativePlatform();
}

export function isWebPlatform() {
  return !Capacitor.isNativePlatform();
}

// All Stripe/purchasing surfaces (price, Subscribe CTAs, Checkout redirect, Customer Portal,
// pricing disclosures used as CTAs) are WEB-ONLY. The native iOS build is a free companion app
// with no in-app purchasing surfaces (App Store Guideline 3.1.1). Default-visible on web.
export function showBillingUI() {
  return isWebPlatform();
}

// Where a trial-expired / locked user is routed. Web keeps its existing Stripe paywall; native
// gets a neutral access-ended screen that contains no purchasing CTAs.
export function expiredRedirectPath() {
  // Both platforms route to the paywall; on iOS the paywall presents the native StoreKit 2 sheet,
  // on web it presents Stripe Checkout.
  return "/paywall";
}

// Development/preview tooling (sample data, paywall-preview toggle) must never be visible to
// production/App Store users. Deterministic: it keys off the backend URL baked into the build.
// It tests for ABSENCE of the production host (not presence of the Preview host) so that the
// Preview hostname literal never appears in the compiled bundle/source map — which would trip the
// production-bundle safeguard. Production builds bake molaroo.navscora.com -> hidden; Preview
// builds and the local dev server bake a non-production backend -> shown.
export function showDevTools() {
  const backend = process.env.REACT_APP_BACKEND_URL || "";
  return backend !== "" && !/molaroo\.navscora\.com/.test(backend);
}
